import React from 'react';

const PanelEmptyState = ({ message }) => {
  return <div className="p-4 text-sm text-muted-foreground caption">{message}</div>;
};

export default PanelEmptyState;
